export default "__VITE_ASSET__B21y$UK0__"